import { apiClient } from './client';

export interface VarioSession {
  access_token: string;
  refresh_token: string;
  expires_at?: number | null;
}

/**
 * Tauscht einen Vario-appToken gegen eine echte Supabase-Session.
 * Das Backend (/api/vario/auth-bridge) antwortet flach mit
 * { access_token, refresh_token, expires_at }.
 */
export async function exchangeAppToken(appToken: string): Promise<VarioSession> {
  const response = await apiClient.post<VarioSession>('/vario/auth-bridge', {
    app_token: appToken,
  });
  return response.data;
}
